import styled, { css } from 'styled-components';
import { Plus10 } from '@elfsight/icons';
import { changeTone, getBrightInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import {
  classnamePrefix,
  MOBILE_WIDTH_SMALL,
  TABLET_WIDTH
} from '../../../../constants';
import { dictionary } from '../../../dictionary';

export const Follow = ({ type, currentBreakpoint, onClick }) => {
  const { accentColor, lang } = useSettings();
  const isSmallMobileSize = currentBreakpoint === MOBILE_WIDTH_SMALL;
  const isTabletSize = currentBreakpoint === TABLET_WIDTH;

  return (
    <Component
      onClick={onClick}
      _accentColor={accentColor}
      _isSmallMobileSize={isSmallMobileSize}
      _isTabletSize={isTabletSize}
    >
      <Plus10
        width="10px"
        height="10px"
        style={{ fill: accentColor && getBrightInvertedColor(accentColor) }}
      />

      {type === 'group'
        ? `${dictionary[lang]?.['Join this'] || dictionary.en['Join this']} ${
            dictionary[lang]?.[type] || dictionary.en[type]
          }`
        : dictionary[lang]?.['Follow'] || dictionary.en['Follow']}
    </Component>
  );
};

const Component = styled.button.attrs({
  className: `${classnamePrefix}-follow-component`
})`
  margin-left: auto;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  border: none !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;
  transition: 0.3s ease background-color;
  cursor: pointer;
  background-color: ${({ _accentColor }) => _accentColor || 'rgb(3, 172, 239)'};
  color: ${({ _accentColor }) =>
    _accentColor ? getBrightInvertedColor(_accentColor) : 'rgb(255, 255, 255)'};

  &:hover {
    background-color: ${({ _accentColor }) =>
      _accentColor
        ? changeTone({ color: _accentColor, amount: 0.1, darken: true })
        : ''};
  }

  ${({ _isSmallMobileSize, _isTabletSize }) =>
    (_isSmallMobileSize || _isTabletSize) &&
    css`
      padding: 3px 10px;
      font-size: 11px;
      line-height: 16px;
      align-self: flex-start;
    `}

  ${({ _isSmallMobileSize }) =>
    _isSmallMobileSize &&
    css`
      margin: 4px auto;
    `}

  & svg {
    display: flex;
    margin-right: 8px;

    ${({ _isSmallMobileSize, _isTabletSize }) =>
      (_isSmallMobileSize || _isTabletSize) &&
      css`
        width: 8px;
        height: 8px;
      `}
  }
`;
